import { render, staticRenderFns } from "./list-order.vue?vue&type=template&id=4d7d03d2&scoped=true&"
import script from "./list-order.vue?vue&type=script&lang=js&"
export * from "./list-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d03d2",
  null
  
)

export default component.exports